/** Fonte única das flags: aba, rota e gateway precisam concordar sobre demo × api. */
export const negotiationReportsApiMode = (): boolean =>
  process.env.NEXT_PUBLIC_NEGOTIATION_REPORTS_MODE === 'api';

/** Keep the unfinished integration hidden unless API mode or an explicit preview is enabled. */
export const negotiationReportsEnabled = (): boolean =>
  negotiationReportsApiMode() || process.env.NEXT_PUBLIC_NEGOTIATION_REPORTS_PREVIEW === 'true';
